import { STATUS_FORM } from '../constants';

export const getPrivacyManagement = (payload, props, setStatusFormDetails) => ({
    type: STATUS_FORM.STATUS_FORM_DETAILS,
    payload: {
        payload,
        props,
        setStatusFormDetails
    }
});
export const statusFormSuccess = (payload) => ({
    type: STATUS_FORM.STATUS_FORM_SUCCESS,
    payload: {
        payload
    }
})
export const getDocStoreReport = (payload, props) => ({
    type: STATUS_FORM.GET_DOC_STORE_REPORT,
    payload : {
        payload,
        props
    }
})
export const getVWGoADocument = (payload, convertDocument) => ({
    type: STATUS_FORM.GET_VWGOA_DOCUMENT,
    payload : {
        payload,
        convertDocument,
    }
})
export const resetStatusReducer = () => ({
    type: STATUS_FORM.RESET_FORM,
})